import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

const AgentContextText = createContext<string | null>(null)
const SetAgentContext = createContext<(text: string | null) => void>(() => undefined)

export function AgentContextProvider({ children }: { children: ReactNode }) {
  const [text, setText] = useState<string | null>(null)
  return (
    <SetAgentContext.Provider value={setText}>
      <AgentContextText.Provider value={text}>{children}</AgentContextText.Provider>
    </SetAgentContext.Provider>
  )
}

export function useAgentContext(lines: readonly string[]): void {
  const setText = useContext(SetAgentContext)
  const text = lines.filter((line) => line !== '').join(' ')
  useEffect(() => {
    setText(text === '' ? null : text)
    return () => setText(null)
  }, [setText, text])
}

export function useCurrentAgentContext(): string | null {
  return useContext(AgentContextText)
}
